import { render, staticRenderFns } from "./ProductionUnitView.vue?vue&type=template&id=26749846"
import script from "./ProductionUnitView.vue?vue&type=script&lang=js"
export * from "./ProductionUnitView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports